// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"d23d75be","174":"de6b2f08","196":"1739ad56","282":"ce6a2821","563":"0e620ec2"}[chunkId] + ".chunk.js";
};